/**
 * WITC / PvP: max points per question by play band (must match
 * `QuizManagementService.GetScoringInfoForDifficulty` on the API).
 */
export function maxPointsForPlayDifficultyBand(difficulty: string | undefined | null): number {
  const d = (difficulty || 'Easy').trim().toLowerCase();
  if (d === 'medium') return 3;
  if (d === 'hard') return 5;
  return 2;
}

export function normalizePlayDifficultyLabel(
  difficulty: string | undefined | null
): 'Easy' | 'Medium' | 'Hard' {
  const d = (difficulty || 'Easy').trim().toLowerCase();
  if (d === 'medium') return 'Medium';
  if (d === 'hard') return 'Hard';
  return 'Easy';
}

/** WITC: wrong attempts before exhaust (reveal + next). Must match GetWitcMaxWrongAttemptsBeforeExhaust on the API. Hard = no second chance. */
export function witcMaxWrongBeforeExhaustForBand(difficulty: string | undefined | null): number {
  const band = normalizePlayDifficultyLabel(difficulty);
  if (band === 'Hard') return 1;
  if (band === 'Medium') return 3;
  return 2;
}

/** WITC solo + PvP: seconds per question by play band. */
export function witcTimeLimitSecondsForBand(difficulty: string | undefined | null): number {
  const band = normalizePlayDifficultyLabel(difficulty);
  if (band === 'Hard') return 7;
  if (band === 'Medium') return 15;
  return 30;
}
